
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    is_link: {
      type: Boolean,
      default: false,
    },
    popup_text: {
      type: String,
      default: "绘画",
    },
    is_popup: {
      type: Boolean,
      default: false,
    },
    is_box: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods:{
    clickPopup(){
      this.$emit('clickPopup');
    },
    clickMore(){
      this.$emit('clickMore');
    }
  }
};
